import pick from 'lodash/pick';

import { createContexts } from '../../utils';

import type { EventDefinition } from '../../types';

export const chatbot_copy_action: EventDefinition = {
  getData: (action, eventData = {}) => ({
    type: action,
    ...pick(eventData, ['copyType', 'hasSources', 'sourceCount']),
  }),
  addContexts: ({ eventData } = {}) => {
    return createContexts(['chat_session', 'chat_message'], { eventData });
  },
};
